import TagManager from "react-gtm-module";

export const initGTM = () => {
  TagManager.initialize({
    gtmId: "GTM-WB3RHSK8",
  });
};
